import withStyles from '@mui/styles/withStyles';
import createStyles from '@mui/styles/createStyles';

import {CommonButton} from './CommonButton.js';

import CommonTheme from '../../../Theme.js';

/** ポジティブボタンで使用するパレット */
const palette = CommonTheme.palette.primary;
const chubuPalette = CommonTheme.chubuPalette.primary;

const styles = (theme) => createStyles({
  root: {
    color: palette.contrastText,
    background: chubuPalette.main,
    borderColor: chubuPalette.main,
  },
});
const styles2 = (theme) => createStyles({
  root: {
    color: '#4F89C6',
    background: '#fff',
    borderColor: '#C0C0C0',
  },
});
const standardStyles = (theme) => createStyles({
  root: {
    color: '#000000',
    backgroundColor: '#FFFFFF',
    borderColor: '#C0C0C0',
  },
});

/** ポジティブボタンスタイル */
export const PositiveButton = withStyles(styles)(CommonButton);
export const PositiveButton2 = withStyles(styles2)(CommonButton);
export const StandardButton = withStyles(standardStyles)(CommonButton);
export default PositiveButton;
